<template>
  <div class="mind-map-view">
    <div class="mind-map-header">
      <button @click="saveMindMap">保存思维导图</button>
      <button @click="showTrash" v-if="!isTrashView">查看回收站</button>
      <button @click="backToList" v-if="isTrashView">返回列表</button>
    </div>
    <div v-if="!isTrashView" class="mind-map-wrapper">
      <MindMap v-model="mindData" />
    </div>
    <div v-else class="trash-list">
      <div v-for="item in trashList" :key="item.id" class="trash-item">
        <span>{{ item.title }}</span>
        <div class="trash-actions">
          <button @click="handleRestore(item.id)">恢复</button>
          <button @click="handleDelete(item.id)">删除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import MindMap from '@/components/MindMap.vue'
import { createMindMap, updateMindMap, softDeleteMindMap, getTrashList, restoreMindMap, getMindMapDetail } from '@/api/mindmap'
import { message } from "ant-design-vue";

const route = useRoute()
const mindData = ref({
  nodeData: {
    topic: '中心主题',
    id: '1',
    children: []
  }
})
const isTrashView = ref(false)
const currentMindMapId = ref(null)
const trashList = ref([])

onMounted(async () => {
  const id = route.query.id
  if (id) {
    currentMindMapId.value = id
    const res = await getMindMapDetail(id)
    // 兼容不同返回结构
    if (res && res.data && res.data.content) {
      mindData.value = res.data.content
    } else if (res && res.content) {
      mindData.value = res.content
    } else {
      // 兜底，防止报错
      mindData.value = {
        nodeData: {
          topic: '中心主题',
          id: '1',
          children: []
        }
      }
    }
  } else {
    currentMindMapId.value = null
    // 新建，保持 mindData 默认值
  }
})

// 保存思维导图
async function saveMindMap() {
  try {
    const data = {
      title: mindData.value.nodeData.topic,
      content: mindData.value
    }
    if (currentMindMapId.value) {
      await updateMindMap(currentMindMapId.value, data)
      message.success({
            content: "更新成功！",
            duration: 3,
          });
    } else {
      const res = await createMindMap(data)
      if(res.status==201){
      message.success({
            content: "创建成功！",
            duration: 3,
          });}
    }
  } catch (error) {
    message.error('保存失败：' + error.message)
  }
}

// 查看回收站
async function showTrash() {
  try {
    const { data } = await getTrashList()
    trashList.value = data
    isTrashView.value = true
  } catch (error) {
    message.error('获取回收站失败：' + error.message)
  }
}

// 恢复思维导图
async function handleRestore(id) {
  try {
    await restoreMindMap(id)
    message.success('恢复成功')
    await showTrash() // 刷新回收站列表
  } catch (error) {
    message.error('恢复失败：' + error.message)
  }
}

// 删除思维导图
async function handleDelete(id) {
  try {
    await softDeleteMindMap(id)
    message.success('删除成功')
    await showTrash() // 刷新回收站列表
  } catch (error) {
    message.error('删除失败：' + error.message)
  }
}

// 返回列表
function backToList() {
  isTrashView.value = false
}

</script>

<style scoped>
.mind-map-view {
  padding: 20px;
}

.mind-map-header {
  margin-bottom: 20px;
}

.mind-map-header button {
  margin-right: 10px;
}

.mind-map-wrapper {
  margin-top: 20px;
  height: calc(100vh - 120px);
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.trash-list {
  margin-top: 20px;
}

.trash-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #e8e8e8;
  margin-bottom: 10px;
  border-radius: 4px;
}

.trash-actions button {
  margin-left: 10px;
}
</style> 